import axios from 'axios';
import dayjs from 'dayjs';

// Radius is in meters
async function getStops(lat = undefined, lon = undefined, radius = undefined) {
  const params = new URLSearchParams();

  if (lat) {
    params.append('lat', lat);
  }

  if (lon) {
    params.append('lon', lon);
  }

  if (radius) {
    params.append('radius', radius);
  }

  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/otp/stops?${params.toString()}`);
  return data;
}

async function getNearbyStops(lat, lon) {
  const params = new URLSearchParams({
    lat,
    lon,
  });

  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/otp/stops/nearby?${params.toString()}`);
  return data;
}

// from and to are strings in the format lng,lat
// maxWalkDistance is in meters
async function getRoute(from, to, mode, dateTime = undefined, maxWalkDistance = 3000) {
  const params = new URLSearchParams({
    fromLat: from.lat,
    fromLng: from.lng,
    toLat: to.lat,
    toLng: to.lng,
    mode,
    maxWalkDistance,
  });

  if (dateTime) {
    const dateTimeObj = dayjs(dateTime);
    params.set('time', dateTimeObj.format('HH:mm:ss'));
    params.set('date', dateTimeObj.format('YYYY-MM-DD'));
  }

  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/otp/route?${params.toString()}`);
  return data;
}

async function getStopsForBbox(minLat, minLon, maxLat, maxLon) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/otp/stops/bbox?minLat=${minLat}&minLon=${minLon}&maxLat=${maxLat}&maxLon=${maxLon}`);
  return data;
}

async function getStop(id) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/otp/stops/${id}`);
  return data.data.stop;
}

export {
  getNearbyStops,
  getRoute,
  getStop,
  getStops,
  getStopsForBbox,
};